import axios from 'axios'

/**
 * The logged-in imobiliária's own plan, read from hcheck (`/web/company/subscription`). The token is
 * the same one this front already holds — the auth server is shared and hcheck is a resource server —
 * so no extra credential is involved.
 *
 * It has to go through hcheck rather than straight to the billing API: billing authenticates with the
 * integrator's key pair, which is not scoped to a company, so a browser bundle carrying it would hold
 * a key to every customer of the integrator. hcheck keeps that key server-side and answers only for
 * the company in the token.
 *
 * Own axios call instead of `checklistApi`: that module captures the token at import time, which is
 * stale for the very first read right after login. Same reason as `entitlementApi`.
 */
const config = () => {
  const baseURL = process.env.VUE_APP_CHECKLIST_API_URL
  const token = localStorage.getItem('access_token')

  if (!baseURL || !token) return null

  return { baseURL, headers: { Authorization: `Bearer ${token}` } }
}

export const fetchCompanySubscription = () => {
  const request = config()
  if (!request) return Promise.reject(new Error('Subscription lookup not configured'))

  return axios.get(`${request.baseURL}/web/company/subscription`, {
    headers: request.headers,
    timeout: 15000,
  })
}

/**
 * Replaces the card on file. The card is sent once over HTTPS and is never stored, cached or logged
 * on the way — hcheck forwards it to billing, which tokenizes it with the broker and keeps only the
 * token plus brand and last four digits.
 *
 * Longer timeout than the read: this is a round trip through billing *and* the payment broker.
 *
 * hcheck answers 200 for every billing state, discriminated by `kind` — `UPDATED`, `REJECTED`,
 * `NOT_READY`, `UNAVAILABLE`. Only a malformed body is a 400.
 */
export const updateCompanyCard = (card) => {
  const request = config()
  if (!request) return Promise.reject(new Error('Card update not configured'))

  return axios.post(`${request.baseURL}/web/company/card`, card, {
    headers: request.headers,
    timeout: 30000,
  })
}
